// import './Header.css';
import React, { useState, useMemo, useCallback, useRef, useEffect } from 'react';
import { Modal, Button, Form, Row, Col } from 'react-bootstrap'
import '../../styles/index.css';
import ReCAPTCHA from "react-google-recaptcha";
import PostAuditLog from '../../utils/Fetches'

function recapVerify(value) {
    console.log("Captcha value:", value);
}
function CarrierAdd(props) {

    const [show, setShow] = useState(false);
    // const handleClose = () => setShow(false);
    const handleClose = () => handleCloseFunc();
    const handleShow = () => { setShow(true); }
    const [carrier, setCarrier] = useState([]);
    const [update, setUpdate] = useState();
    const cellValue = props.valueFormatted ? props.valueFormatted : props.value;

    const [formValidated, setFormValidated] = useState(true)
    const [validationSuccess, setValidationSuccess] = useState(false)
    const [carrierId, setCarrierId] = useState("");
    const [carrierName, setCarrierName] = useState("");
    const [address1, setAddress1] = useState("");
    const [address2, setAddress2] = useState();
    const [city, setCity] = useState("");
    const [province, setProvince] = useState("");
    const [postalCode, setPostalCode] = useState("");
    const [email, setEmail] = useState("");
    const [phone, setPhone] = useState("");
    const [status, setStatus] = useState();

    const [carrierNameWarning, setCarrierNameWarning] = useState();
    const [address1Warning, setAddress1Warning] = useState();
    const [addressWarning2, setAddress2Warning] = useState();
    const [cityWarning, setCityWarning] = useState();
    const [provinceWarning, setProvinceWarning] = useState();
    const [postalCodeWarning, setPostalCodeWarning] = useState();
    const [emailWarning, setEmailWarning] = useState();
    const [phoneWarning, setPhoneWarning] = useState();
    const [statusWarning, setStatusWarning] = useState();
    const [formWarning, setFormWarning] = useState();


    const [firstName, setFirstName] = useState("");
    const [lastName, setLastName] = useState("");
    const [userEmail, setUserEmail] = useState("");
    const [password, setPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState();
    const [firstNameWarning, setFirstNameWarning] = useState();
    const [lastNameWarning, setLastNameWarning] = useState();
    const [emailInAuth0, setEmailInAuth0] = useState(false);
    const [emailInDatabase, setEmailInDatabase] = useState(false);
    const [userEmailWarning, setUserEmailWarning] = useState();
    const [userEmailPrePostWarning, setUserEmailPrePostWarning] = useState();
    const [passwordValidated, setPasswordValidate] = useState(false);
    const [passwordPrePostWarning, setPasswordPrePostWarning] = useState();
    const [passwordWarning, setPasswordWarning] = useState();

    //File Upload
    const [selectedFile, setSelectedFile] = useState();
    const [isSelected, setIsSelected] = useState();

    const [adminFormFile, setAdminFormFile] = useState();
    const [carrierFormFile, setCarrierFormFile] = useState();

    const [carrierAgreement, setCarrierAgreement] = useState();
    const [adminAgreement, setAdminAgreement] = useState();


    const [isCarrierFormSelected, setIsCarrierFormSelected] = useState(false);
    const [isAdminFormSelected, setIsAdminFormSelected] = useState(false);

    const [ formButtonEnabled, setFormButtonEnabled] = useState(false);

    function handleCloseFunc() {
        setShow(false)
        clearAllFields()
        clearValidations()
        
    }


    const addCarrier = async (event) => {
        // event.preventDefault();
        setFormButtonEnabled(true)
        var carrierCheck = true;
        var status = ""
        // var currentCarrierId = "";
        const carrier_data = {
            "carrierName": carrierName,
            "email": email,
            "phone": phone,
            "status": "Pending",
            "address": address1,
            "address2": null,
            "drivers": null,
            "city": city,
            "province": province,
            "postalCode": postalCode,
            "carrierAgreement": carrierAgreement,
            
        }

        // Create Carrier through Rest API call
        await fetch(process.env.REACT_APP_HOST_BACKEND + '/api/Carrier/', {
            method: 'POST',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json',
                // 'Authorization': `Token ${token['mytoken']}`,
            },
            body: JSON.stringify(carrier_data),
        })
            .then(resp => 
            {
                if(resp.status == 200) {
                    PostAuditLog("Carrier Add", "Adding carrier, " + carrierName + " was a success.", props.userId)
                }
                else{
                    PostAuditLog("Carrier Add", "Adding carrier, " + carrierName + " failed.", props.userId)
                    setFormButtonEnabled(false)
                    carrierCheck = false;
                    setFormWarning(<i class="las la-exclamation-circle" style={{color:"red"}}>There was a problem in creating the user. Please try again.</i>)
                    return;
                }
            }    
            )
            // .then(resp => {
            //     console.log(resp)
            // })
            .catch(error => {
                PostAuditLog("Carrier Add", "Adding carrier, " + carrierName + " failed.", props.userId)
                setFormButtonEnabled(false)
                carrierCheck = false;
                setFormWarning(<i class="las la-exclamation-circle" style={{color:"red"}}>There was a problem in creating the user. Please try again.</i>)
                return;
            })

        props.refresh()
        if(carrierCheck == true) {
            setFormButtonEnabled(false)
            setShow(false);
            clearAllFields()
        }
        
    }

    // Set File
    const carrierAgreementFormChangeHandler = (event) => {
        setCarrierFormFile(event.target.files[0]);
        setIsCarrierFormSelected(true);
    };

    const adminFormChangeHandler = (event) => {
        setAdminFormFile(event.target.files[0]);
        setIsAdminFormSelected(true);
    };

    // Upload File to database
    const handleCarrierAgreementFormSubmission = (event) => {
        event.preventDefault();

        const formData = new FormData();
        formData.append('File', carrierFormFile);

        fetch(
            process.env.REACT_APP_HOST_BACKEND + '/File/UploadFiles',
            {
                method: 'POST',
                body: formData,
            }
        )
            .then((response) => response.json())
            .then((result) => {
                setCarrierAgreement(result);
                console.log('Success:', result);
            })
            .catch((error) => {
                console.error('Error:', error);
            });
    };

    const handleAdminFormSubmission = (event) => {
        event.preventDefault();

        const formData = new FormData();

        formData.append('File', adminFormFile);

        fetch(
            process.env.REACT_APP_HOST_BACKEND + '/File/UploadFiles',
            {
                method: 'POST',
                body: formData,
            }
        )
            .then((response) => response.json())
            .then((result) => {
                setAdminAgreement(result);
                console.log('Success:', result);
            })
            .catch((error) => {
                console.error('Error:', error);
            });
    };

    function clearValidations() {
        setCarrierNameWarning()
        setAddress1Warning()
        setCityWarning()
        setProvinceWarning()
        setPostalCodeWarning()
        setEmailWarning()
        setPhoneWarning()
        setFormWarning()
    }

    function clearAllFields() {
        setCarrierName("")
        setAddress1("")
        setCity("")
        setProvince("")
        setPostalCode("")
        setEmail("")
        setPhone("")
    }

    function formValidation() {
        clearValidations()
        const postalCodeCheck = new RegExp(/^[ABCDEFGHIJKLMNOPQRSTUVWXYZ]\d[ABCDEFGHIJKLMNOPQRSTUVWXYZ][ -]?\d[ABCDEFGHIJKLMNOPQRSTUVWXYZ]\d$/i);
        const passwordCheck = new RegExp(/^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])[0-9a-zA-Z]{8,}$/);
        const emailCheck = new RegExp(/^([\w-\.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([\w-]+\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(\]?)$/);
        var validation = true;
        if (!emailCheck.test(email)) {
            setFormValidated(false)
            validation = false;
            setEmailWarning(<i class="las la-exclamation-circle" style={{color:"red"}}>The format of the email is wrong.</i>)
        }
        if (!carrierName.trim()) {
            setFormValidated(false)
            validation = false;
            setCarrierNameWarning(<i class="las la-exclamation-circle" style={{color:"red"}}>Carrier name is not set.</i>)
        }
        if (!address1.trim()) {
            setFormValidated(false)
            validation = false;
            setAddress1Warning(<i class="las la-exclamation-circle" style={{color:"red"}}>Address is not set.</i>)
        }
        if (!city.trim()) {
            setFormValidated(false)
            validation = false;
            setCityWarning(<i class="las la-exclamation-circle" style={{color:"red"}}>City is not set.</i>)
        }
        if (!province.trim()) {
            setFormValidated(false)
            validation = false;
            setProvinceWarning(<i class="las la-exclamation-circle" style={{color:"red"}}>Province is not set.</i>)
        }
        if (!postalCodeCheck.test(postalCode)) {
            setFormValidated(false)
            validation = false;
            setPostalCodeWarning(<i class="las la-exclamation-circle" style={{color:"red"}}>Please enter a valid postal code.</i>)
        }
        if (!postalCode.trim()) {
            setFormValidated(false)
            validation = false;
            setPostalCodeWarning(<i class="las la-exclamation-circle" style={{color:"red"}}>Postal code is not set.</i>)
        }
        if (!email.trim()) {
            setFormValidated(false)
            validation = false;
            setEmailWarning(<i class="las la-exclamation-circle" style={{color:"red"}}>Email is not set.</i>)
        }
        if (!phone.trim()) {
            setFormValidated(false)
            validation = false;
            setPhoneWarning(<i class="las la-exclamation-circle" style={{color:"red"}}>Phone is not set.</i>)
        }
        // formValidated(true)
        
        if (formValidated == false || validation == false) {
            setFormValidated(true);
            validation = true
            return;
        } else {
            addCarrier()
        }
    }



    function checkEmail(value) {
        let emailWarningMessage = ""
        let user_email_data = {
            email: value
        }
        setUserEmailPrePostWarning();

        fetch(process.env.REACT_APP_HOST_BACKEND + '/api/User/check_email/' + value, {
            method: 'GET',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json',
            },
            // body: JSON.stringify(data),
        })
            // .then(resp => resp.json())
            .then(resp => resp.text())
            .then(json => {
                let driverLogo = ""
                if (json == "User found.") {
                    emailWarningMessage = <i class="las la-exclamation-circle" style={{color:"red"}}>The user already exists.</i>
                    setEmailInDatabase(true)
                    setFormValidated(false)
                }
                else if (json == "User not found.") {
                    emailWarningMessage = <i class="las la-check-circle">User available.</i>
                    setEmailInDatabase(false)
                    setFormValidated(true)
                }
                setUserEmailPrePostWarning(emailWarningMessage)
            })
            .catch(error => {
                console.log(error);
            })
    }

    function checkPassword() {
        let passwordMessage = ""
        if (password != confirmPassword && password != '' && confirmPassword != '') {

            setFormValidated(false)
            setPasswordValidate(false)
            passwordMessage = <i class="las la-exclamation-circle" style={{color:"red"}}>The password confirmation does not match.</i>
            setFormValidated(false);
        } else if (password == confirmPassword && password != '' && confirmPassword != '') {
            setPasswordValidate(true)
            setFormValidated(true)
        }
        setPasswordPrePostWarning(passwordMessage)
    }

    // useEffect(() => {
    //     checkPassword()
    // }, [password, confirmPassword])


    // Don't remove yet for testing
    // https://localhost:44482/register?carrierName=John&address=111+test+st.&postal=R1R1R1&city=Winnipeg&province=Manitoba&email=test@email.com&phone=2042042042

    // const encrypt = btoa("?carrierName=John&address=111+test+st.&postal=R1R1R1&city=Winnipeg&province=Manitoba&email=test@email.com&phone=2042042042")
    // console.log("~query btoa: " + encrypt)
    // console.log("~query atob: " + atob(encrypt))
    // console.log("~query cname: " + carrierNameParam)
    // console.log("~query address: " + addressParam)
    // console.log("~query postal: " + postalParam)
    // console.log("~query city: " + cityParam)
    // console.log("~query province: " + provinceParam)
    // console.log("~query email: " + emailParam)
    // console.log("~query phone: " + phoneParam)  

    return (
        <>
            <button className='btn btn-primary' onClick={handleShow} style={{ borderRadius: '50px', width:130}}>+ Add Carrier</button>
            <Modal show={show} onHide={window.location.pathname != "/register" ? handleClose : ""}>
                <Modal.Header closeButton>
                <Modal.Title>Add Carrier</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form>
                        <Row className="mb-3">
                            <Form.Group as={Col} >
                                <Form.Control type="text" value={carrierName} placeholder="Carrier Name" onChange={(e) => setCarrierName(e.target.value)} required />
                                {carrierNameWarning}
                            </Form.Group>
                        </Row>

                        <Row className="mb-3">
                            <Form.Group as={Col} >
                                <Form.Control type="text" value={address1} placeholder="Enter address" onChange={(e) => setAddress1(e.target.value)} required />
                                {address1Warning}
                            </Form.Group>

                            <Form.Group as={Col} >
                                <Form.Control type="text" value={postalCode} placeholder="Enter postal code" onChange={(e) => setPostalCode(e.target.value)} required />
                                {postalCodeWarning}
                            </Form.Group>
                        </Row>

                        <Row className="mb-3">
                            <Form.Group as={Col} >
                                <Form.Control type="text" value={city} placeholder="Enter city" onChange={(e) => setCity(e.target.value)} required />
                                {cityWarning}
                            </Form.Group>

                            <Form.Group as={Col} >
                                <Form.Control type="text" value={province} placeholder="Enter province" onChange={(e) => setProvince(e.target.value)} required />
                                {provinceWarning}
                            </Form.Group>
                        </Row>

                        <Row className="mb-3">
                            <Form.Group as={Col} >
                                <Form.Control type="text" value={email} placeholder="Enter email" onChange={(e) => setEmail(e.target.value)} required />
                                {emailWarning}
                            </Form.Group>

                            <Form.Group as={Col} >
                                <Form.Control type="text" value={phone} placeholder="Enter phone" onChange={(e) => setPhone(e.target.value)} required />
                                {phoneWarning}
                            </Form.Group>
                        </Row>
                        {formWarning}
                        {/* <Row className="mb-3">
                            <Form.Group as={Col} >
                                <Form.Label>Form*</Form.Label>
                            </Form.Group>
                        </Row> */}
                    {/* <Row className="mb-3">
                        <Form.Group as={Col} >
                            <div>
                                <input type="file" name="file" onChange={carrierAgreementFormChangeHandler} />
                                {isCarrierFormSelected ? (
                                    <div>
                                        <p>Filename: {carrierFormFile.name}</p>
                                    </div>
                                ) : (
                                    <p>Upload a file to show details</p>
                                )}
                            </div>
                        </Form.Group>
                        <Form.Group as={Col}>
                            <button className="btn btn-secondary" onClick={handleCarrierAgreementFormSubmission}>Upload</button>
                        </Form.Group>
                    </Row> */}
                </Form>
                <Button variant="primary" onClick={() => formValidation()} disabled={formButtonEnabled}>
                    Save Carrier
                </Button>
                </Modal.Body>
            </Modal>
          
        </>
    );
}

export default CarrierAdd;
